export default 'Welcome to eMentored.';
